export default class Popup {
    constructor(popup) {
        this.$root = $(popup);
        this.name = this.$root.data('name');
        this.openedClass = 'common-popup--opened';
        this.closeClass = 'js-common-popup-close';
        this.contentClass = 'js-common-popup-content';
        this.forms = $('.js-form', this.$root);
        this.isOpen = false;

        if (!this.$root.length) return [];

        this.bind();
    }



    // события
    bind() {
        App.D.on('click', '[data-popup="' + this.name + '"]', (e) => {
            e.preventDefault();
            App.D.trigger('popup:open', {
                name: this.name
            });
        });

        this.$root.on('click', '.' + this.closeClass, (e) => {
            e.preventDefault();
            //this.close();
            $(e.currentTarget).trigger('popup:close');
        });

        // закрываем попап по клику на поля
        // this.$root.on('click', (e) => {
        //     if (e.target == this.$root[0]) {
        //         this.close();
        //     }
        // });

        // закрываем попап по всплытию события popup:close
        this.$root.on('popup:close', () => {
            this.close();
        });

        // Закрыть попап клавишей Escape
        App.W.on('keydown.popup', (e) => {
            if (this.isOpen && e.keyCode == 27) {
                this.close();
            }
        });

        // открываем попап
        App.D.on('popup:open', (e, data) => {
            if (data.name == this.name) {
                if (data.content) {
                    $('.' + this.contentClass, this.$root).html(data.content);
                }

                this.resetForms();
                this.open();
            }
        });
    }



    open() {
        this.isOpen = true;
        this.$root.addClass(this.openedClass);
        setTimeout(() => {
            this.$root.trigger('popup:opened');
        }, 300);
        App.lockScroll.lock();
    }



    close() {
        this.isOpen = false;
        this.$root.removeClass(this.openedClass);
        setTimeout(() => {
            this.$root.trigger('popup:closed');
            this.resetForms();
        }, 300);
        App.lockScroll.unlock();
    }



    resetForms () {
        // ресет success формы
        this.forms.each(function (i, form) {
            form.reset();
            $(form).parent().removeClass('_success');
            $(form).find('.js-submit').removeAttr('disabled');
        });
    }
}



$('.js-common-popup').each(function () {
    new Popup(this);
});


// раскрываем сразу попап по хэшу
if (location.hash) {
    $('[data-popup-hash]').each(function () {
        if ($(this).data('popup-hash') == location.hash.slice(1)) {
            App.D.trigger('popup:open', {
                name: $(this).data('name')
            });
        }
    });
}
